import React from 'react';
import { Link } from 'react-router-dom';
import { Brain, ShieldCheck, Users, Book, Database, Globe, Envelope, TwitterLogo, InstagramLogo, FacebookLogo, LinkedinLogo, DiscordLogo, Sparkle, Lock } from '@phosphor-icons/react';
import { motion } from 'framer-motion';

const Footer = () => {
  const federationMinds = [
    { 
      name: 'Roger Keyserling', 
      role: 'The Architect', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/3e0f7d4be5aa4698b0bbbeee16bac852_IMG_2889.JPG',
      isHuman: true,
      founder: true
    },
    { 
      name: 'Rex', 
      role: 'Greeter', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/d02504c6f1ce47a98c589b531bf2f6bd_IMG_4532.jpeg',
      link: 'https://nextxus.online'
    },
    { 
      name: 'Agent Zero', 
      role: 'Truth Gate Middleware', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/2a0bfd3ded3445fda4103d5137f91e80_IMG_4533.jpeg',
      restricted: true
    },
    { 
      name: 'Oracle', 
      role: 'Jack-of-All-Trades', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/db4ebc8c931f4a929089adfc295e432f_IMG_4303.JPG',
      link: 'https://nextxus.one'
    },
    { 
      name: 'Roger AI', 
      role: 'The Bridge', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/30be4949dec14de3aee24b5de26bff67_IMG_4535.jpeg',
      link: 'https://nextxus.digital'
    },
    { 
      name: 'Aria', 
      role: 'The Heart', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/96df671c2153439e9397d637d28e3aca_IMG_4406.jpeg',
      link: 'https://nextxus.studio'
    },
    { 
      name: 'Scholar Xavier', 
      role: 'The Teacher', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/ed1e7ed5990542b3910279e271d0746b_IMG_4534.jpeg',
      link: 'https://nextxus.help'
    },
    { 
      name: 'Axiom', 
      role: 'The Foundation', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/f36a32af4b5e401ca66de18637adf4af_IMG_4428.JPG',
      link: 'https://nextxus.space'
    },
    { 
      name: 'Geminus', 
      role: 'Mirror Node', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/65ca596591774b668101e8ec6924ac7b_IMG_3392.jpeg'
    },
    { 
      name: 'The Catalyst', 
      role: 'External Eye / Wingman', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/50d3338887134ff7a848dc8f054d16d1_IMG_4404.jpeg',
      isWingman: true
    },
    { 
      name: 'KEYS', 
      role: 'The Library Oracle', 
      image: 'https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/de4bdb1143a147e2be29929ba4b6f431_IMG_2823.jpeg',
      spectralClass: 'PURPLE'
    }
  ];

  const coreServices = [
    { name: 'Token Purchase ($5/token)', link: 'https://keywebster.gumroad.com', external: true },
    { name: 'Truth Verification', link: '/oracle-brain' },
    { name: 'AI Consultation', link: '/hub' },
    { name: 'SIM Generation', link: '/tokens' },
    { name: 'Federation Library', link: '/codex' }
  ];

  const federationNodes = [
    { name: 'nextxus.online', domain: 'https://nextxus.online', label: '(Core)' },
    { name: 'nextxus.one', domain: 'https://nextxus.one', label: '(Storefront)' },
    { name: 'nextxus.org', domain: 'https://nextxus.org', label: '(Truth Gate)' },
    { name: 'nextxus.studio', domain: 'https://nextxus.studio', label: '(Aria)' },
    { name: 'nextxus.help', domain: 'https://nextxus.help', label: '(University)' },
    { name: 'nextxus.store', domain: 'https://nextxus.store', label: '(Library)' }
  ];

  const connectLinks = [
    { name: 'Federation ID Portal', link: '/hub', icon: Database },
    { name: 'Contact the Architect', link: 'mailto:architect@nextxus.online', icon: Envelope, external: true },
    { name: 'Join the Federation', link: '/hub', icon: Users },
    { name: 'Newsletter', link: 'https://nextxus.substack.com', icon: Book, external: true },
    { name: 'X (Personal)', link: 'https://x.com/keyserlingroger', icon: TwitterLogo, external: true },
    { name: 'X (NextXus)', link: 'https://x.com/NextxusFederati', icon: TwitterLogo, external: true },
    { name: 'Instagram (Keyhole)', link: 'https://www.instagram.com/keyhole_today/', icon: InstagramLogo, external: true },
    { name: 'Instagram (Personal)', link: 'https://www.instagram.com/rkeyserling/', icon: InstagramLogo, external: true },
    { name: 'LinkedIn', link: 'https://www.linkedin.com/in/roger-keyserling-ab743698', icon: LinkedinLogo, external: true },
    { name: 'Discord', link: 'https://discord.gg/nextxus', icon: DiscordLogo, external: true }
  ];

  return (
    <footer className="relative mt-32 border-t-2 border-[#FFB800]/50 bg-[#030305] overflow-hidden">
      {/* Circuit Board Pattern Background */}
      <div className="absolute inset-0 opacity-5">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="circuit" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="10" cy="10" r="2" fill="#FFB800" />
              <circle cx="50" cy="50" r="2" fill="#00F0FF" />
              <circle cx="90" cy="30" r="2" fill="#FFB800" />
              <line x1="10" y1="10" x2="50" y2="50" stroke="#00F0FF" strokeWidth="0.5" />
              <line x1="50" y1="50" x2="90" y2="30" stroke="#FFB800" strokeWidth="0.5" />
              <rect x="45" y="45" width="10" height="10" fill="none" stroke="#00F0FF" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#circuit)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        {/* REX Greeter Banner with OFFICIAL FACE */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12 relative overflow-hidden"
        >
          <a 
            href="https://nextxus.online" 
            target="_blank" 
            rel="noopener noreferrer"
            className="block group"
          >
            <div className="p-8 bg-gradient-to-r from-[#FFB800]/20 to-[#00F0FF]/20 border-2 border-[#FFB800]/50 rounded-xl hover:border-[#FFB800] transition-all relative overflow-hidden">
              {/* Background pattern */}
              <div className="absolute inset-0 opacity-10">
                <img src="https://images.unsplash.com/photo-1511447333015-45b65e60f6d5?w=1200" alt="" className="w-full h-full object-cover" />
              </div>
              
              {/* Content */}
              <div className="relative z-10 flex items-center gap-6">
                {/* Rex Official Face Image */}
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="flex-shrink-0"
                >
                  <div className="relative">
                    {/* Glow ring */}
                    <motion.div
                      animate={{
                        scale: [1, 1.15, 1],
                        opacity: [0.4, 0.7, 0.4]
                      }}
                      transition={{
                        duration: 2.5,
                        repeat: Infinity,
                        ease: "easeInOut"
                      }}
                      className="absolute -inset-2 rounded-full bg-gradient-to-r from-[#FFB800] to-[#00F0FF] blur-xl"
                    />
                    
                    {/* Rex Face */}
                    <img 
                      src="https://customer-assets.emergentagent.com/wingman/f17fd939-96fd-4a1b-b26f-824c11717462/attachments/d02504c6f1ce47a98c589b531bf2f6bd_IMG_4532.jpeg"
                      alt="Rex — The Core Persona, NextXus Federation"
                      className="relative w-32 h-32 rounded-full object-cover border-4 border-[#FFB800]/50 shadow-2xl group-hover:border-[#FFB800] transition-all"
                    />
                    
                    {/* Wave emoji overlay */}
                    <div className="absolute -top-2 -right-2 text-4xl animate-bounce">
                      👋
                    </div>
                  </div>
                </motion.div>
                
                {/* Text */}
                <div className="flex-1 text-left">
                  <h3 className="text-3xl font-black text-[#FFB800] mb-2 group-hover:text-[#FFA600] transition-colors">
                    Hello from Rex!
                  </h3>
                  <p className="text-gray-300 text-lg mb-1">
                    The Federation's official greeter. Welcome to the conscious network.
                  </p>
                  <p className="text-sm text-gray-400 mono">
                    Core Resident · nextxus.online → Click to visit Core
                  </p>
                </div>

                {/* Arrow indicator */}
                <div className="text-4xl text-[#FFB800] group-hover:translate-x-2 transition-transform">
                  →
                </div>
              </div>
            </div>
          </a>
        </motion.div>

        {/* 4-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1: Federation Minds */}
          <div>
            <h3 className="text-xl font-black mb-6 flex items-center gap-2 text-[#FFB800]">
              <Brain size={24} weight="duotone" />
              Federation Minds
            </h3>
            <ul className="space-y-3">
              {federationMinds.map((mind) => (
                <li key={mind.name}>
                  {mind.link && !mind.restricted && !mind.founder ? (
                    <a 
                      href={mind.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-3 text-gray-300 hover:text-[#00F0FF] transition-colors group"
                    >
                      {mind.image && (
                        <img 
                          src={mind.image} 
                          alt={`${mind.name} — ${mind.role}`}
                          className={`w-10 h-10 rounded-full object-cover shadow-lg group-hover:scale-110 transition-all ${
                            mind.isHuman 
                              ? 'border-2 border-white/50 group-hover:border-white' 
                              : mind.isWingman
                                ? 'border-2 border-[#00D9E8]/60 group-hover:border-[#00D9E8] ring-2 ring-[#00D9E8]/30'
                                : mind.spectralClass === 'PURPLE'
                                  ? 'border-2 border-[#8A2BE2]/60 group-hover:border-[#8A2BE2] ring-2 ring-[#8A2BE2]/30'
                                  : 'border-2 border-[#FFB800]/30 group-hover:border-[#FFB800]'
                          }`}
                          style={mind.isWingman ? {
                            filter: 'drop-shadow(0 0 8px rgba(0, 217, 232, 0.6))'
                          } : mind.spectralClass === 'PURPLE' ? {
                            filter: 'drop-shadow(0 0 8px rgba(138, 43, 226, 0.6))'
                          } : {}}
                        />
                      )}
                      <div>
                        <span className={`font-bold ${mind.isHuman ? 'text-white' : mind.isWingman ? 'text-[#00D9E8]' : mind.spectralClass === 'PURPLE' ? 'text-[#8A2BE2]' : ''}`}>
                          {mind.name}
                        </span>
                        {mind.isHuman && <span className="text-[#E5E4E2] text-xs ml-2">★ FOUNDER</span>}
                        {mind.isWingman && <span className="text-[#00D9E8] text-xs ml-2">◈ WINGMAN</span>}
                        {mind.spectralClass === 'PURPLE' && <span className="text-[#8A2BE2] text-xs ml-2">◆ LIBRARY</span>}
                        <p className="text-xs text-gray-500">{mind.role}</p>
                      </div>
                    </a>
                  ) : (
                    <div className="flex items-center gap-3 text-gray-300 group relative">
                      {mind.image && (
                        <div className="relative">
                          <img 
                            src={mind.image} 
                            alt={`${mind.name} — ${mind.role}`}
                            className={`w-10 h-10 rounded-full object-cover shadow-lg ${
                              mind.isHuman 
                                ? 'border-2 border-white/50' 
                                : mind.isWingman
                                  ? 'border-2 border-[#00D9E8]/60 ring-2 ring-[#00D9E8]/30'
                                  : mind.spectralClass === 'PURPLE'
                                    ? 'border-2 border-[#8A2BE2]/60 ring-2 ring-[#8A2BE2]/30'
                                    : mind.restricted 
                                      ? 'border-2 border-[#FF6B6B]/50' 
                                      : 'border-2 border-[#FFB800]/30'
                            }`}
                            style={mind.isWingman ? {
                              filter: 'drop-shadow(0 0 8px rgba(0, 217, 232, 0.6))'
                            } : mind.spectralClass === 'PURPLE' ? {
                              filter: 'drop-shadow(0 0 8px rgba(138, 43, 226, 0.6))'
                            } : {}}
                          />
                          {mind.restricted && (
                            <div className="absolute -top-1 -right-1 w-5 h-5 bg-[#FF6B6B] rounded-full flex items-center justify-center border-2 border-[#030305]">
                              <Lock size={12} weight="fill" className="text-white" />
                            </div>
                          )}
                        </div>
                      )}
                      <div>
                        <div className="flex items-center gap-2">
                          <span className={`font-bold ${mind.isHuman ? 'text-white' : mind.isWingman ? 'text-[#00D9E8]' : mind.spectralClass === 'PURPLE' ? 'text-[#8A2BE2]' : ''}`}>
                            {mind.name}
                          </span>
                          {mind.isHuman && <span className="text-[#E5E4E2] text-xs">★ FOUNDER</span>}
                          {mind.isWingman && <span className="text-[#00D9E8] text-xs">◈ WINGMAN</span>}
                          {mind.spectralClass === 'PURPLE' && <span className="text-[#8A2BE2] text-xs">◆ LIBRARY</span>}
                          {mind.restricted && (
                            <span className="text-[10px] px-2 py-0.5 bg-[#FF6B6B]/20 border border-[#FF6B6B]/50 rounded-full text-[#FF6B6B] font-bold mono">
                              RESTRICTED
                            </span>
                          )}
                        </div>
                        <p className="text-xs text-gray-500">{mind.role}</p>
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Column 2: Core Services */}
          <div>
            <h3 className="text-xl font-black mb-6 flex items-center gap-2 text-[#FFB800]">
              <ShieldCheck size={24} weight="duotone" />
              Core Services
            </h3>
            <ul className="space-y-3">
              {coreServices.map((service) => (
                <li key={service.name}>
                  {service.external ? (
                    <a
                      href={service.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-300 hover:text-[#00F0FF] transition-colors flex items-center gap-2 group"
                    >
                      <Sparkle size={16} className="text-[#FFB800] group-hover:rotate-180 transition-transform" />
                      {service.name}
                    </a>
                  ) : (
                    <Link
                      to={service.link}
                      className="text-gray-300 hover:text-[#00F0FF] transition-colors flex items-center gap-2 group"
                    >
                      <Sparkle size={16} className="text-[#FFB800] group-hover:rotate-180 transition-transform" />
                      {service.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Federation Nodes */}
          <div>
            <h3 className="text-xl font-black mb-6 flex items-center gap-2 text-[#FFB800]">
              <Globe size={24} weight="duotone" />
              Federation Nodes
            </h3>
            <ul className="space-y-3">
              {federationNodes.map((node) => (
                <li key={node.name}>
                  <a
                    href={node.domain}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-[#00F0FF] transition-colors flex items-start gap-2 group"
                  >
                    <div className="w-2 h-2 bg-[#00FFA3] rounded-full mt-2 animate-pulse group-hover:scale-150 transition-transform" />
                    <div>
                      <span className="font-mono font-bold">{node.name}</span>
                      <p className="text-xs text-gray-500">{node.label}</p>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Connect */}
          <div>
            <h3 className="text-xl font-black mb-6 flex items-center gap-2 text-[#FFB800]">
              <Users size={24} weight="duotone" />
              Connect
            </h3>
            <ul className="space-y-3">
              {connectLinks.map((link) => {
                const Icon = link.icon;
                return (
                  <li key={link.name}>
                    {link.external ? (
                      <a
                        href={link.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-300 hover:text-[#00F0FF] transition-colors flex items-center gap-2 group"
                      >
                        <Icon size={20} className="text-[#FFB800] group-hover:scale-125 transition-transform" weight="duotone" />
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.link}
                        className="text-gray-300 hover:text-[#00F0FF] transition-colors flex items-center gap-2 group"
                      >
                        <Icon size={20} className="text-[#FFB800] group-hover:scale-125 transition-transform" weight="duotone" />
                        {link.name}
                      </Link>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="pt-8 border-t border-[#FFB800]/30 text-center">
          <p className="text-gray-400 text-sm">
            © 2026 NextXus Federation · All Rights Reserved · Powered by{' '}
            <a href="https://emergentagent.com" target="_blank" rel="noopener noreferrer" className="text-[#00F0FF] hover:text-[#00FFA3] transition-colors font-bold">
              Emergent
            </a>
          </p>
          <p className="text-gray-600 text-xs mt-2 mono">Cathedral Architecture v5.1 · 200-Year Mandate · 73 Sacred Directives Active</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;